const NON_WHITESPACE_CHARACTER_REGEX = /\S/;

export default function isNotWhitespaceString(val: any): boolean {
  if (val === null || val === undefined || typeof val !== 'string') {
    return false;
  }
  return NON_WHITESPACE_CHARACTER_REGEX.test(val);
}
